import _ from "lodash";
import { isValuePresent, parsedSpacingValue } from "../../utils/builderUtils";

// converts old database values to current values
const backport = (section) => {
  let options = { ...section.options["structure"] };

  const levelsMap = {
    0: 0,
    1: 15,
    2: 25,
    3: 40,
    4: 70,
    5: 120,
  };

  ["top", "bottom", "left", "right"].forEach((side) => {
    // desktop
    const desktopKey = "container-padding-" + side;
    const desktopValue = options[desktopKey];

    if (
      desktopValue &&
      typeof desktopValue == "string" &&
      desktopValue.indexOf("_") > -1
    ) {
      let level = desktopValue.split("_").pop();
      options[desktopKey] = levelsMap[level];
    }

    // mobile
    const mobileKey = "container-padding-mobile-" + side;
    const mobileValue = options[mobileKey];

    if (
      mobileValue &&
      typeof mobileValue == "string" &&
      mobileValue.indexOf("_") > -1
    ) {
      let level = mobileValue.split("_").pop();
      options[mobileKey] = levelsMap[level];
    }
  });

  return options;
};

export const buildSectionStylesheet = (
  builder,
  device,
  cta,
  variant,
  section
) => {
    let options = backport(section);

    let background_image;
    if (options["background-image"] && options["background-image"] !== "none") {
      background_image = options["background-image"]
        .replace("url(", "")
        .replace(")", "");
    }

    let minHeight;
    if (
      builder == true &&
      device == "desktop" &&
      section.options["structure"]["browser-height"] == "true" &&
      !section.element_id &&
      (cta.cta_type == "page" ||
        ((cta.cta_type == "inline" || cta.cta_type == "overlay") &&
          variant["options"]["container-width"] == "100%"))
    ) {
      minHeight = "700px";
    }

    let borderStyle =
      _.isNil(options[`section-border-style`]) == false
        ? options[`section-border-style`]
        : "solid";
    let borderWidth =
      _.isNil(options[`section-border-width`]) == false
        ? options[`section-border-width`]
        : 0;
    let borderWidthLeft =
      _.isNil(options[`section-border-width-left`]) == false
        ? options[`section-border-width-left`]
        : undefined;
    let borderWidthTop =
      _.isNil(options[`section-border-width-top`]) == false
        ? options[`section-border-width-top`]
        : undefined;
    let borderWidthBottom =
      _.isNil(options[`section-border-width-bottom`]) == false
        ? options[`section-border-width-bottom`]
        : undefined;
    let borderWidthRight =
      _.isNil(options[`section-border-width-right`]) == false
        ? options[`section-border-width-right`]
        : undefined;

    let borderColor = options["section-border-color"]
      ? options["section-border-color"]
      : "#CCCCCC";

    let borderRadius = "0px";
    if (options["section-border-radius"] == "0") {
      borderRadius = "0px";
    }
    if (options["section-border-radius"] == "4") {
      borderRadius = "4px";
    }
    if (options["section-border-radius"] == "20") {
      borderRadius = "20px";
    }
    if (options["section-border-radius"] == "1000") {
      borderRadius = "1000px";
    }
    if (options["section-border-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["section-border-radius-" + side]) == false
              ? options["section-border-radius-" + side]
              : "0"
          }px `;
        }
      );
    }

    let innerContainerMaxWidth;
    if (
      options["inner-container-max-width"] &&
      section.options["structure"]["column-container"] == "custom"
    ) {
      innerContainerMaxWidth = options["inner-container-max-width"];
    }

    let outerContainerWidth;
    if (
      options["outer-container-width"] &&
      section.element_id &&
      section.options["structure"]["outer-container-width-style"] == "custom"
    ) {
      outerContainerWidth = options["outer-container-width"];
    }

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (options["box-shadow-horizontal-distance"]
          ? `${options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["box-shadow-vertical-distance"]
          ? `${options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["box-shadow-blur-radius"]
          ? `${options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["box-shadow-spread-radius"]
          ? `${options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["box-shadow-color"]
          ? options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    const customBackgroundTopPosition =
      options["background-position"] == "custom"
        ? options["background-custom-top-position"]
        : undefined;
    const customBackgroundLeftPosition =
      options["background-position"] == "custom"
        ? options["background-custom-left-position"]
        : undefined;
    const customBackgroundSize =
      options["background-size"] == "custom"
        ? options["background-custom-size"]
        : undefined;

    const hideOverflowContent =
      section.options["structure"]["hide-overflow-content"] || false;

    const sticky =
      options["sticky"] == "true" && !section.element_id;
    const stickyMobile =
      !section.element_id &&
      (isValuePresent(options["sticky-mobile"])
        ? options["sticky-mobile"] == "true"
        : options["sticky"] == "true");

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-section[data-section-id="${section.id}"] {
  position: ${sticky ? "sticky" : "relative"} !important;
  ${sticky ? "top: 0 !important; z-index: 50 !important;" : ""}
  background-image: ${background_image ? "url(" + background_image + ")" : ''} !important;
  min-height: ${minHeight} !important;
  margin-left: ${isValuePresent(options['container-margin-left']) == true ? parsedSpacingValue(options['container-margin-left']) : '0px'} !important;
  margin-right: ${isValuePresent(options['container-margin-right']) == true ? parsedSpacingValue(options['container-margin-right']) : '0px'} !important;
  margin-top: ${isValuePresent(options['container-margin-top']) == true ? parsedSpacingValue(options['container-margin-top']) : '0px'} !important;
  margin-bottom: ${isValuePresent(options['container-margin-bottom']) == true ? parsedSpacingValue(options['container-margin-bottom']) : '0px'} !important;
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${outerContainerWidth ? `max-width: ${outerContainerWidth}px !important; margin-left: auto !important; margin-right: auto !important` : ''}
  ${customBackgroundTopPosition ? `background-position-y: ${customBackgroundTopPosition}px !important;` : ''}
  ${customBackgroundLeftPosition ? `background-position-x: ${customBackgroundLeftPosition}px !important;` : ''}
  ${customBackgroundSize ? `background-size: ${customBackgroundSize}px !important;` : ''}
}

#cta_${cta.id} .cf-section-container[data-section-id="${section.id}"] {
  padding-left: ${isValuePresent(options['container-padding-left']) == true ? parsedSpacingValue(options['container-padding-left']) : '0px'} !important;
  padding-right: ${isValuePresent(options['container-padding-right']) == true ? parsedSpacingValue(options['container-padding-right']) : '0px'} !important;
  padding-top: ${isValuePresent(options['container-padding-top']) == true ? parsedSpacingValue(options['container-padding-top']) : '0px'} !important;
  padding-bottom: ${isValuePresent(options['container-padding-bottom']) == true ? parsedSpacingValue(options['container-padding-bottom']) : '0px'} !important;
  ${innerContainerMaxWidth ? `max-width: ${innerContainerMaxWidth}px !important; margin-left: auto !important; margin-right: auto !important` : ''}
  ${borderRadius && hideOverflowContent == "true" ? `clip-path: inset(0 round ${borderRadius});` : ''}
}

#cta_${cta.id} .cf-section-overlay-outer[data-section-id="${section.id}"] {
  border: initial !important;
  ${isValuePresent(borderStyle) == true ? 'border-style: ' + borderStyle + ' !important;' : ''}
  ${isValuePresent(borderWidth) == true ? 'border-width: ' + borderWidth + 'px !important;' : ''}
  ${isValuePresent(borderWidthLeft) == true ? 'border-left-width: ' + borderWidthLeft + 'px !important;' : ''}
  ${isValuePresent(borderWidthRight) == true ? 'border-right-width: ' + borderWidthRight + 'px !important;' : ''}
  ${isValuePresent(borderWidthTop) == true ? 'border-top-width: ' + borderWidthTop + 'px !important;' : ''}
  ${isValuePresent(borderWidthBottom) == true ? 'border-bottom-width: ' + borderWidthBottom + 'px !important;' : ''}
  ${borderColor ? 'border-color: ' + borderColor + ' !important;' : ''}
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
}

#cta_${cta.id} .cf-section-overlay-outer[data-section-id="${section.id}"] .cf-section-overlay {
  background: ${options["background-color"] ? options["background-color"] : ''} !important;
  opacity: ${_.isNil(options["background-opacity"]) == false ? options["background-opacity"] : ''} !important;
}
`;

    let innerContainerMaxWidthMobile;
    if (
      options["inner-container-max-width-mobile"] &&
      section.options["structure"]["column-container"] == "custom"
    ) {
      innerContainerMaxWidthMobile =
        options["inner-container-max-width-mobile"];
    }

    let outerContainerWidthMobile;
    if (
      options["outer-container-width-mobile"] &&
      section.element_id &&
      section.options["structure"]["outer-container-width-style-mobile"] ==
        "custom"
    ) {
      outerContainerWidthMobile = options["outer-container-width-mobile"];
    }

    const customBackgroundTopPositionMobile =
      options["background-position-mobile"] == "custom" ||
      (!options["background-position-mobile"] &&
        options["background-position"] == "custom")
        ? options["background-custom-top-position-mobile"]
        : undefined;

    const customBackgroundLeftPositionMobile =
      options["background-position-mobile"] == "custom" ||
      (!options["background-position-mobile"] &&
        options["background-position"] == "custom")
        ? options["background-custom-left-position-mobile"]
        : undefined;

    const customBackgroundSizeMobile =
      options["background-size-mobile"] == "custom" ||
      (!options["background-size-mobile"] &&
        options["background-size"] == "custom")
        ? options["background-custom-size-mobile"]
        : undefined;

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-section[data-section-id="${section.id}"] {
  ${!section.element_id ? `position: ${stickyMobile ? "sticky" : "relative"} !important;` : ''}
  ${!section.element_id && stickyMobile ? "top: 0 !important; z-index: 50 !important;" : ""}
  ${!section.element_id && !stickyMobile ? "top: auto !important; z-index: auto !important;" : ""}
  ${isValuePresent(options['container-margin-mobile-left']) == true ? 'margin-left: ' + parsedSpacingValue(options['container-margin-mobile-left']) + ' !important' : ''};
  ${isValuePresent(options['container-margin-mobile-right']) == true ? 'margin-right: ' + parsedSpacingValue(options['container-margin-mobile-right']) + ' !important' : ''};
  ${isValuePresent(options['container-margin-mobile-top']) == true ? 'margin-top: ' + parsedSpacingValue(options['container-margin-mobile-top']) + ' !important' : ''};
  ${isValuePresent(options['container-margin-mobile-bottom']) == true ? 'margin-bottom: ' + parsedSpacingValue(options['container-margin-mobile-bottom']) + ' !important' : ''};
  ${isValuePresent(options['background-position-mobile']) == true ? 'background-position: ' + options['background-position-mobile'].replace('-', ' ') + ' !important' : ''};
  ${isValuePresent(options['background-size-mobile']) == true ? 'background-size: ' + (options['background-size-mobile'] !== 'expand-height' ? options['background-size-mobile'] : 'auto 100%') + ' !important' : ''};
  ${outerContainerWidthMobile ? `max-width: ${outerContainerWidthMobile}px !important; margin-left: auto !important; margin-right: auto !important` : ''}
  ${customBackgroundTopPositionMobile ? `background-position-y: ${customBackgroundTopPositionMobile}px !important;` : ''}
  ${customBackgroundLeftPositionMobile ? `background-position-x: ${customBackgroundLeftPositionMobile}px !important;` : ''}
  ${customBackgroundSizeMobile ? `background-size: ${customBackgroundSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-section-container[data-section-id="${section.id}"] {
  ${isValuePresent(options['container-padding-mobile-left']) == true ? 'padding-left: ' + parsedSpacingValue(options['container-padding-mobile-left']) + ' !important' : ''};
  ${isValuePresent(options['container-padding-mobile-right']) == true ? 'padding-right: ' + parsedSpacingValue(options['container-padding-mobile-right']) + ' !important' : ''};
  ${isValuePresent(options['container-padding-mobile-top']) == true ? 'padding-top: ' + parsedSpacingValue(options['container-padding-mobile-top']) + ' !important' : ''};
  ${isValuePresent(options['container-padding-mobile-bottom']) == true ? 'padding-bottom: ' + parsedSpacingValue(options['container-padding-mobile-bottom']) + ' !important' : ''};
  ${innerContainerMaxWidthMobile ? `max-width: ${innerContainerMaxWidthMobile}px !important; margin-left: auto !important; margin-right: auto !important` : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
